// extracted by mini-css-extract-plugin
export default {"container":"SupplierPalletsNumberToPickUp_container__NoFfJ","divider":"SupplierPalletsNumberToPickUp_divider__ct7wB"};